import { z } from 'zod'
import { stringSchema } from './common'

export const relatedSchema = z.object({
  id: stringSchema.min(1),
  parentId: stringSchema.nullish(),
  image: stringSchema.nullish(),
  path: stringSchema.min(1),
  title: stringSchema.min(1),
  favourited: stringSchema.nullish(),
})
